import { FIELD_ICON_CODE_MAP } from '../const/ui';
import { FieldType } from '@baishuyun/types';
import { FontIcon } from './font-icon';
import { FormulasIcon } from './bs-icons';

export const FieldIcon = ({ type }: { type: FieldType }) => {
  const code = FIELD_ICON_CODE_MAP[type] || 'unknown';
  if (type === 'formula') {
    return <FormulasIcon />;
  }

  return <FontIcon code={code} />;
};
